type Props = {
  outline?: boolean;
  children: React.ReactNode;
};

export const TimeWindowHeaderWrapper = ({ outline, children }: Props) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '10px',
      }}
    >
      {children}
    </div>
  );
};
